<div class="row">
  <div class="col-12 mb-3">
    Identificación del propietario de la tarjeta:
  </div>
  <div class="col-12 col-lg-6">
    <lib-input-select-material-design
      [items]="getTipoDocumentoOptions(tiposDocumento)"
      [control]="controlTipoIdentificacion"
      label="Tipo de identificación"
      id="id-lista-mes-expiracion"
      [wasValidate]="submitted"
      (handleChange)="handleChangeTipoDocumento($event)"
    ></lib-input-select-material-design>
  </div>
  <div class="col-12 col-lg-6">
    <lib-input-material-design
      [control]="controlNumeroIdentificacion"
      label="Número de identificación"
      id="id-texto-numero-identificacion"
      [wasValidate]="submitted"
      [maxlength]="maxLengthNumeroIdentificacion"
      textTransform="capitalize"
      [enableTolowercase]="true"
    ></lib-input-material-design>
  </div>
  <div class="col-12 col-lg-6" *ngIf="controlNombres.enabled">
    <lib-input-material-design
      [control]="controlNombres"
      label="Nombres"
      id="id-texto-nombres"
      [wasValidate]="submitted"
      [maxlength]="50"
      textTransform="capitalize"
      [enableTolowercase]="true"
    ></lib-input-material-design>
  </div>
  <div class="col-12 col-lg-6" *ngIf="controlApellidos.enabled">
    <lib-input-material-design
      [control]="controlApellidos"
      label="Apellidos"
      id="id-texto-apellidos"
      [wasValidate]="submitted"
      [maxlength]="50"
      textTransform="capitalize"
      [enableTolowercase]="true"
    ></lib-input-material-design>
  </div>
  <div class="col-12" *ngIf="controlRazonSocial.enabled">
    <lib-input-material-design
      [control]="controlRazonSocial"
      label="Razón social"
      id="id-texto-razon-social"
      [wasValidate]="submitted"
      [maxlength]="50"
      textTransform="capitalize"
    ></lib-input-material-design>
  </div>
  <div class="col-12 mb-3">
    <b class="d-block info-titular">Información del titular de la tarjeta</b>
  </div>
  <div class="col-12">
    <lib-input-material-design
      [control]="controlCorreo"
      label="Correo electrónico"
      id="id-texto-correo-electronico"
      [wasValidate]="submitted"
      [maxlength]="50"
      [enableTolowercase]="true"
      inputType="email"
    ></lib-input-material-design>
  </div>
  <div class="col-12 col-lg-6">
    <lib-typeahead
      [control]="controlCiudad"
      [items]="ciudades"
      keyToShow="nombre"
      id="id-texto-ciudad"
      label="Ciudad"
      [wasValidate]="submitted"
      (itemSelected)="handleChangeCiudad($event)"
    ></lib-typeahead>
  </div>
  <div class="col-12 col-lg-6">
    <lib-input-material-design
      [control]="controlTelefono"
      label="Teléfono o celular"
      id="id-texto-telefono"
      [wasValidate]="submitted"
      inputType="number"
    ></lib-input-material-design>
  </div>
  <div class="col-12">
    <lib-input-material-design
      [control]="controlDireccion"
      label="Dirección"
      [maxlength]="100"
      id="id-texto-telefono"
      [wasValidate]="submitted"
      (handleChange)="handleChangeDireccion()"
    ></lib-input-material-design>
  </div>
</div>
